import { trackClick } from '@hotjar/webapp/features/Playbacks/utils/tracking';
import type { Store } from '../../../store/player/types';
import { getJumpDirectionBy } from './getJumpDirectionBy';

/**
 * Track sidebar event click.
 */

export const trackSidebarEventClick = (
  recordingStore: Store,
  time: number,
  name: string,
  type: string,
): void => {
  const { recording } = recordingStore.getState();
  if (!recording) return;

  const jumpDirection = getJumpDirectionBy(time);
  const trackingParams = {
    element_name: `playback_jumped_${jumpDirection}`,
    state_event_was_triggered_on: 'playback.player_navigation',
    ui_position: `clicked_on_event_sidebar-${name ?? type}`,
  };

  trackClick(recording, trackingParams);
};
